export default __webpack_public_path__ + "static/media/ic_saudi_arabia.d6d01f4a.svg";